export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12780.18d6c3d3.jpg";